import React from 'react';
import { Doughnut as DoughnutChart } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Colors,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, Colors);

interface DoughnutProps {
  labels: string[];
  data: any;
}

function Doughnut({ labels, data }: DoughnutProps) {
  const doughnutData = {
    labels,
    datasets: [
      {
        data,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
        borderWidth: 0,
        borderRadius: 0,
        borderSkipped: false,
        barThickness: 20,
        backgroundColor: [
          '#CF9EE0',
          '#9BE3E2',
          '#AE5DCC',
          '#84DDDB',
          '#772E92',
          '#59D1CE',
          '#800080',
          '#6A287E',
        ],
      },
    ],
  };

  return (
    <div className="h-full w-full flex items-center">
      <div className="h-72 w-full  ">
        <DoughnutChart
          data={doughnutData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            cutout: 0,
            plugins: {
              legend: {
                position: 'bottom',
              },
            },
            scales: {
              x: {
                display: false,
                grid: {
                  display: false,
                },
              },
              y: {
                display: false,
                grid: {
                  display: false,
                },
              },
            },
          }}
        />
      </div>
    </div>
  );
}

export default Doughnut;
